<style scoped lang="scss">
  .note{
    display: flex;
    align-items: flex-start;
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
        font-size: 16px;
      }
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .con{
      display: none!important;
    }
    .wrap-intel{
      margin-bottom: 0!important;
    }
    .cons{
      display: block!important;
    }
    .cons .device{
      display: block!important;
    }
    .cons .device li{
      width: 100% !important;
      display: block!important;
      height: 385px;
    }
    .wrap-intel .container{
      width: 90% !important;
    }
    .gene_img{
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .gene_img img{
      width: 100%;
    }
  }
  .cons{
    display: none;
  }
</style>
<template>

  <div class="wrap wrap-intel">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/设备及原料/仪器设备/banner2.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>合成配套设备</h1>-->
<!--          <h2 class="mt10">满足不同需求的DNA/RNA合成</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;" v-if="!$route.meta.invisibles">
      <bread></bread>
    </div>
    <section class="container" v-if="!$route.meta.invisibles">
      <div class="con">
        <ul class="device">
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/氨解仪.png">
            <div class="info">
              <h4>氨解仪</h4>
              <p>DNAchem-AM096氨解仪是用来氨解DNAchem合成仪系列合成出来的...</p>
              <router-link class="btn btn-primary" to="/intel/am096">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/溶解仪.png">
            <div class="info">
              <h4>单体溶解仪</h4>
              <p>DNAchemR01溶解仪用来溶解DNAchem系列单体设计出来的定量加液设备...</p>
              <router-link class="btn btn-primary" to="/intel/R01">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/768纯化仪.png">
            <div class="info">
              <h4>纯化仪</h4>
              <p>用于培养基生产企业、制药企业、医院、公共健康、疾病预防控制中心...</p>
              <router-link class="btn btn-primary" to="/intel/AKTA">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/离心浓缩仪.png" width="250">
            <div class="info">
              <h4>离心浓缩仪</h4>
              <p>离心浓缩仪采用离心力、真空和加热相结合的方法使样品中的溶剂快速蒸发，从而...</p>
              <router-link class="btn btn-primary" to="/intel/CTT">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/除湿系统.png" width="250">
            <div class="info">
              <h4>防腐蚀转轮除湿系统</h4>
              <p>防腐蚀转轮除湿系统通过机械按钮+湿度控制的方式严格控制合成室内的温湿度。</p>
              <router-link class="btn btn-primary" to="/intel/DHFSYS">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="cons">
        <ul class="device">
          <li>
            <div class="gene_img"><img src="@/assets/img/设备及原料/仪器设备/氨解仪.png"></div>
            <div class="info">
              <h4>氨解仪</h4>
              <p>DNAchem-AM096氨解仪是用来氨解DNAchem合成仪系列合成出来的...</p>
              <router-link class="btn btn-primary" to="/intel/am096">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/img/设备及原料/仪器设备/溶解仪.png"></div>
            <div class="info">
              <h4>单体溶解仪</h4>
              <p>DNAchemR01溶解仪用来溶解DNAchem系列单体设计出来的定量加液设备...</p>
              <router-link class="btn btn-primary" to="/intel/R01">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/img/设备及原料/仪器设备/768纯化仪.png"></div>
            <div class="info">
              <h4>纯化仪</h4>
              <p>用于培养基生产企业、制药企业、医院、公共健康、疾病预防控制中心...</p>
              <router-link class="btn btn-primary" to="/intel/AKTA">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <qk-consult type="Virus1"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/device_2.vue